module.exports = __webpack_public_path__ + "static/media/love_icon_blank.268aabad.svg";